import { get } from 'lodash';
import { call, fork, put, take, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import {
	REFUND_REPORTS_REQUESTING,
	REFUND_REPORTS_SUCCESS,
	REFUND_REPORTS_ERROR,
	GENERATING_REPORT_ERROR,
	GENERATING_REPORT_REQUESTING,
	GENERATING_REPORT_SUCCESS,
} from '@/redux/ducks/refundReports/types';
import Api from '@/data';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import { getObjValue } from '@/utils/helper';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';

export const getFilters = (state) => state.refundReports.filters;

export function* fetchRefund(payload) {
	try {
		yield put({
			type: REFUND_REPORTS_REQUESTING,
			payload,
		});
		const response = yield call(Api.reportList, payload);
		yield put({
			type: REFUND_REPORTS_SUCCESS,
			data: getObjValue(response, 'data'),
		});
		// Call fetch refund again if the uploaded file is in processing state.
		while (response.data[0].state === 'PROCESSING') {
			yield put({
				type: REFUND_REPORTS_REQUESTING,
				payload,
			});
			const secondResponse = yield call(Api.reportList, payload);
			yield put({
				type: REFUND_REPORTS_SUCCESS,
				data: getObjValue(secondResponse, 'data'),
			});
			yield call(delay, 6000);
			response.data[0].state = secondResponse.data[0].state;
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: REFUND_REPORTS_ERROR, error: error.data });
		}
	}
}

export function* getRefundReportsList() {
	while (true) {
		const action = yield take(REFUND_REPORTS_REQUESTING);
		yield call(fetchRefund, action.payload);
	}
}

export function* generateReport(payload) {
	try {
		yield put({
			type: GENERATING_REPORT_REQUESTING,
			payload,
		});
		const response = yield call(Api.generateReport, payload);
		yield put({
			type: GENERATING_REPORT_SUCCESS,
			data: response.data,
		});
		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: 'Report generation in progress. Please wait…',
				type: 'info',
			},
		});
		// Calling fetch refund report again to refresh the report list
		const refundReportListFilter = yield select(getFilters);
		yield put({
			type: REFUND_REPORTS_REQUESTING,
			payload: refundReportListFilter,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: GENERATING_REPORT_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
		}
	}
}

export function* generateRefundReportWatcher() {
	while (true) {
		const action = yield take(GENERATING_REPORT_REQUESTING);
		yield call(generateReport, action.payload);
	}
}

function* refundReportsFlowSaga() {
	yield fork(getRefundReportsList);
	yield fork(generateRefundReportWatcher);
}

export default refundReportsFlowSaga;
